'use es6';

import PropTypes from 'prop-types';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DashedLabel from '../../atoms/DashedLabel';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { getChannelSettingsUrl } from '../../url/getChannelSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "TicketCreationFailure__Bold",
  componentId: "sc-14uftl9-0"
})(["font-weight:600;"]);
const TicketCreationFailure = ({
  inboxId
}) => {
  const href = getChannelSettingsUrl({
    inboxId
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    "data-test-id": 'ticket-creation-failure-message',
    type: 'error',
    textAlign: 'text-left',
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'conversations-inbox-message-history.ticket-creation-failure.description_jsx',
      options: {
        href
      },
      elements: {
        UIIcon,
        Bold,
        UILink
      }
    })
  });
};
TicketCreationFailure.displayName = 'TicketCreationFailure';
TicketCreationFailure.propTypes = {
  inboxId: PropTypes.number.isRequired
};
export default TicketCreationFailure;